module.exports = __webpack_public_path__ + "img/info-sign.d213896f.svg";